/**
 * Entry point da SPA.
 *
 * O projeto deixou de usar SSR (TanStack Start): o configurador e uma
 * ferramenta interativa pos-clique, nao conteudo indexavel pagina a pagina.
 * Toda a logica de dominio vive em `@montebox/shared`, entao reintroduzir SSR
 * no futuro significa trocar a camada de roteamento — nada do dominio muda.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import { getRouter } from "./router";
import "./styles.css";

const router = getRouter();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Elemento #root nao encontrado no index.html');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
